<template>
<div class="in-report-manage">
    <component :is="views"></component>
</div>
</template>

<script>
import rsList from '@/views/SSGL/components/ssList';
export default {
    data() {
        return {
            views: rsList
        }
    },
    methods: {},
    mounted() {}
}
</script>
